import 'babel-polyfill';
import { polyfill } from 'es6-promise';
polyfill();
import fontawesome from '../../_common/fa';
import Vue from 'vue';

//  Application
import { createRouter } from './router';
import state from './state';
import filters from '../../_common/filters/index';
import currencyFilter from './filters/currency.filter';
import 'normalize.css';

//  Plugins
import themePlugin from '../../_common/plugins/theme.plugin';
import routerPlugin from '../../_common/plugins/router.plugin';
import statePlugin from '../../_common/plugins/state.plugin';
import httpPlugin from '../../_common/plugins/http.plugin';
import i18nPlugin from '../../_common/plugins/i18n.plugin';

/* vue settings */
const debug = process.env.NODE_ENV !== 'production';
Vue.config.productionTip = debug;

/* import route handlers */
import redpipeRouteHandler from './routehandlers/common/redpipe.routehandler';
import authRouteHandler from './routehandlers/common/auth.routehandler';
//import welcomeLinksRouteHandler from './routehandlers/common/welcome-links.routehandler';

/* localization */
import en from './i18n/en.json';
import ru from './i18n/ru.json';
import fr from './i18n/fr.json';
import es from './i18n/es.json';

import { getTheme } from './services/theme.service';
import { syncDeviceStateLoop } from './services/device.service';
import pushService from '../../_common/services/push.service';
import { setRedPipeApiHost } from './services/resources.service';
import idleService from './services/idle.service.js';
// import { registerServiceWorker } from '../../_common/utils';
// registerServiceWorker('/sw.js');

/* state */
Vue.use(statePlugin, { state });
/* http */
Vue.use(httpPlugin, { timeout: 5 * 1000 });
/* i18n */
Vue.use(i18nPlugin, {
    state,
    languages: [{ name: 'en', file: en }, { name: 'ru', file: ru }, { name: 'fr', file: fr }, { name: 'es', file: es }],
    fallbackLanguage: 'en'
});

// register globally
import Modal from './components/_base/modal/modal.vue';
import ModalLink from './components/_base/modal-link/africa/modal-link.vue';
import Loading from './components/_base/loading/africa/loading.vue';
import authService from '../../_common/services/authentication.service';
Vue.component('modal', Modal);
Vue.component('modal-link', ModalLink);
Vue.component('loading', Loading);

/* focus */
Vue.directive('focus', { inserted: el => el.focus() });

/* touch to simulation mouse */
// function touchHandler(event) {
//     var touches = event.changedTouches,
//         first = touches[0],
//         type = "";
//     switch(event.type)
//     {
//         case "touchstart": type = "mousedown"; break;
//         case "touchmove":  type = "mousemove"; break;
//         case "touchend":   type = "mouseup";   break;
//         default:           return;
//     }
//     // initMouseEvent(type, canBubble, cancelable, view, clickCount,
//     //                screenX, screenY, clientX, clientY, ctrlKey,
//     //                altKey, shiftKey, metaKey, button, relatedTarget);

//     var simulatedEvent = document.createEvent("MouseEvent");
//     simulatedEvent.initMouseEvent(type, true, true, window, 1,
//                                   first.screenX, first.screenY,
//                                   first.clientX, first.clientY, false,
//                                   false, false, false, 0/*left*/, null);

//     first.target.dispatchEvent(simulatedEvent);
//     event.preventDefault();
// }
// function initTouchHandler(element) {
//     element.addEventListener("touchstart", touchHandler, true);
//     element.addEventListener("touchmove", touchHandler, true);
//     element.addEventListener("touchend", touchHandler, true);
//     element.addEventListener("touchcancel", touchHandler, true);
// }

// Vue.directive('touchSimulationMouse', {
//     inserted: function (el) {
//         initTouchHandler(el);
//     }
// });

/* touch*/
Vue.directive('touch', {
    inserted: function(el) {
        el.addEventListener('touchstart', function() {
            el.classList.add('touch');
        });

        el.addEventListener('touchend', function() {
            el.classList.remove('touch');
        });
    }
});

const insertAreaAddClass = (el, options) => {
    if (options) {
        el.classList.add('insert-area');
        el.classList.add(`insert-area_horizontal_${options.horizontal || 'none'}`);
        el.classList.add(`insert-area_vertical_${options.vertical || 'none'}`);
    }
};
/* insert area */
Vue.directive('insert-area', function(el, binding) {
    insertAreaAddClass(el, binding.value);
    Vue.nextTick(() => insertAreaAddClass(el, binding.value));
});

/* game size */
Vue.directive('game-size', {
    inserted: function(el, binding) {
        var offsetX = 0;
        var offsetY = 0;

        if (typeof binding.value == 'object') {
            if (binding.value.offsetX) offsetX = binding.value.offsetX;
            if (binding.value.offsetY) offsetY = binding.value.offsetY;
        }

        _getSize();

        window.addEventListener('resize', function() {
            _getSize();
        });

        function _getSize() {
            var koef = 10 / 16;
            var frame = el.getElementsByClassName('game-frame')[0];
            var width = el.clientWidth - offsetX;
            var height = el.clientHeight - offsetY;
            if (frame.classList.contains('is')) koef = 3 / 4;
            if (frame.classList.contains('ne') || frame.classList.contains('ib')) koef = 9 / 16;

            if (height / koef > width) {
                frame.style.width = width + 'px';
                frame.style.height = width * koef + 'px';
            } else {
                frame.style.width = height / koef + 'px';
                frame.style.height = height + 'px';
            }
        }
    }
});

function setTheme(theme) {
    // theme = {main:'africa', mobile: 'africa-mobile'};
    // theme = { main:'club-soft', mobile: 'club-soft-mobile', skin: 'green' };

    var actualTheme = { main: theme.main, mobile: theme.mobile, skin: theme.skin };

    if (theme.main === 'black' || theme.main === 'deep-blue' || theme.main === 'infobox') {
        actualTheme = { main: 'club-soft', mobile: 'club-soft-mobile', skin: 'green' };
    }

    Vue.use(themePlugin, actualTheme);
    document.body.classList.add(actualTheme.main);

    if (actualTheme.subTheme) {
        document.body.classList.add(actualTheme.subTheme);
    }

    if (actualTheme.skin) {
        document.body.classList.add(`skin-${actualTheme.skin}`);
    }
}

// starting application
setTimeout(start, 2000);

async function login(authToken) {
    if (!authToken) return false;
    console.log('fast login');
    const loginResult = await authService.fastlogin(authToken);
    return loginResult && loginResult.isSuccess;
}

async function logginLoop(authToken, resolve, reject) {
    try {
        let result = await login(authToken);
        if (result) {
            resolve();
            return;
        }
    } catch (e) {
        console.error(e);
    }
    setTimeout(async () => {
        await logginLoop(authToken, resolve, reject);
    }, 5000);
}

function isLoginPath() {
    return location.pathname.indexOf('/login/') == 0;
}

async function authenticate() {
    let promise = new Promise(async (resolve, reject) => {
        if (!isLoginPath()) {
            resolve();
            return;
        }
        console.log('login request detected');
        const authToken = location.pathname.split('/').pop();
        await logginLoop(authToken, resolve, reject);
    });

    return promise;
}

function xplay_setLoadingText(text) {
    console.log('preloader: ' + text);
    var div = document.querySelector('#loading-progress-bar');
    if (div) div.innerText = text;
}

async function start() {
    console.log('starting application');

    // Show message untill internet is down
    if (!navigator.onLine) {
        xplay_setLoadingText('Waiting for internet connection...');
        // setTimeout(start, 1000);

        // kiosk is working offline, so it should load even without internet connection
        // return;
    }

    try {
        console.log('authentication');
        await authenticate();
        // NOTE: workaround to fix whitescreen on kiosk load
        var stuckTimeout = setTimeout(() => onBootsrapError('No response for the client info request'), 5000);

        xplay_setLoadingText('Authorization...');
        await state.client.ensure();
        clearTimeout(stuckTimeout);

        const client = state.client.get();

        if (!client) throw new Error('client is not loaded');

        // set RedPipe local host url
        console.log('set redpipe local host url');
        if (client.redPipe && client.redPipe.gameResourcesUrl) setRedPipeApiHost(client.redPipe.gameResourcesUrl);

        console.log('pick theme from client settings (default) or from branch/player');
        // pick theme from client settings (default) or from branch/player
        const defaultClientTheme = getTheme(state);
        xplay_setLoadingText('Configuring kiosk...');
        var player = await Vue.state.player.ensure();

        if (player && player.skin) {
            let skin = '';
            if (player.branchParameters && player.branchParameters.kiosk) {
                const kioskParams = JSON.parse(player.branchParameters.kiosk);
                skin = (kioskParams && kioskParams.skin && kioskParams.skin.color) || '';
            }

            setTheme({ main: player.skin, mobile: '', skin: skin });
        } else {
            setTheme(defaultClientTheme);
        }

        // prelaod games
        xplay_setLoadingText('Loading amazing games...');
        var games = await Vue.state.games.ensure();

        // preload images
        xplay_setLoadingText('Loading pictures from all over the world ...');
        const allGamesResources = games.categories
            .flatMap(category => category.games)
            .flatMap(({ thumbnailUrl, backgroundUrl }) => {
                var gameResources = [];
                thumbnailUrl && gameResources.push(thumbnailUrl);
                backgroundUrl && gameResources.push(backgroundUrl);

                return gameResources;
            });

        const staticFiles = [
            '/static/theme/africa/bg-lobby.png',
            '/static/theme/africa/card-frame.png',
            '/static/theme/africa/icons/coins.svg',
            '/static/theme/africa/africa-logo.png',
            '/static/theme/africa/arrow.svg',
            '/static/theme/africa/icons/union.svg',
            '/static/theme/africa/progress-arrow.svg',
            '/static/theme/africa/progress-coin-inner.svg',
            '/static/theme/africa/progress-coin-outer.svg',
            '/static/theme/africa/bg-modal-withdraw-1.png',
            '/static/theme/africa/bg-modal-withdraw-2.png',
            '/static/theme/africa/bg-modal-withdraw-3.png',
            '/static/theme/africa/deposit-successfull.svg',
            '/static/theme/africa/deposit-direct-error.svg',
            '/static/theme/africa/mpesa-logo.svg',
            '/static/theme/africa/fon.svg',
            '/static/theme/africa/betting-license-2025.jpg',
            '/static/theme/africa/betting-license-2026.jpg',
            '/static/games/fortuna-thumb.jpg',
            '/static/games/fortuna-black-thumb.jpg',
            '/static/games/spin-to-win-suit-thumb.jpg',
            '/static/games/spin-to-win-violet-thumb.jpg',
            '/static/games/aviator-thumb.jpg',
            '/static/games/happy-hour-friut-slot-thumb.jpg',
            '/static/games/safari-big-7-thumb.jpg',
            '/static/games/mega-fruits-thumb.jpg',
            '/static/games/jet-thumb.jpg',
            '/static/games/happy-fruits-thumb.jpg',
            '/static/games/pilotx-thumb.jpg',
            '/static/games/pilot-thumb.jpg',
            '/static/games/rocket-thumb.jpg',
            '/static/theme/africa/phone-with-code.png'
        ];

        const resourcesToLoad = allGamesResources.concat(staticFiles);
        let loadedResourcesCount = 0;
        const reportProgress = () =>
            xplay_setLoadingText(`Loading pictures from all over the world ${loadedResourcesCount++}/${resourcesToLoad.length}...`);

        reportProgress();
        const promises = resourcesToLoad.map(file => Vue.http.get(file, { timeout: 20 * 1000 }).then(reportProgress));

        try {
            await Promise.all(promises);
        } catch (error) {
            console.error('Failed to load pictures for lobby: ', error);
        }

        xplay_setLoadingText('Looking for local resources...');
        try {
            await store.dispatch('localResources/loadStoredGames');
            await store.dispatch('localResources/loadSystemInfo');
        } catch (error) {
            console.log('Failed loading list stored games: ', error);
        }

        // get device logo
        try {
            await store.dispatch('device/getDeviceLogo');
        } catch (error) {
            console.log('Error loading the device logo:', error);
        }

        // get payment system settiings
        xplay_setLoadingText('Requesting payments methods...');
        if (client.paymentSystem.paymentSystemDepositAllowed || client.paymentSystem.paymentSystemWithdrawalAllowed) {
            console.log('getting payment system settings');
            await store.dispatch('payment/loadMethods');
        }

        /* router */
        const router = await createRouter([authRouteHandler, redpipeRouteHandler]);
        Vue.use(routerPlugin, { router });

        if (isLoginPath()) {
            router.push('/');
        }

        /* show error page in case of error */
        Vue.http.interceptors.response.use(
            response => response,
            async error => {
                if (!error.response) {
                    if (router.currentRoute.hash !== '#error-response' && router.currentRoute.hash !== '#out-of-service') {
                        // TODO: better to push error to some external storage
                        // router.push('#error-response');
                    }
                    return Promise.reject(error);
                }

                if (
                    router.currentRoute.hash !== '#out-of-service' &&
                    !router.currentRoute.path.includes('error') &&
                    !router.currentRoute.path.includes('menu') &&
                    (!error.response || error.response.status == 400)
                ) {
                    store.dispatch('error/setError', error.response);
                    router.push({ path: '#error' });
                    return Promise.reject(error);
                }

                if (error.response.status === 401 || error.response.status === 403) {
                    await state.player.logout();
                    router.push({ name: 'start' });
                    return;
                }

                return Promise.reject(error);
            }
        );

        xplay_setLoadingText('Exchange currencies...');
        await state.currencies.ensure();

        /* try start poll jackpots by requesting branch corresponding to hallCode from persistent settings */
        console.log('try start poll jackpots by requesting branch corresponding to hallCode from persistent settings');
        const hallCode = store.get('settings/hallCode');
        hallCode && store.dispatch('hall/set', hallCode);

        /* fix anchor link */
        const fixIdScrolling = {
            watch: {
                $route(to, from) {
                    const currentRoute = this.$router.currentRoute;
                    const idToScrollTo = currentRoute.hash;
                    this.$nextTick(() => {
                        if (idToScrollTo && document.querySelector(idToScrollTo)) {
                            document.querySelector(idToScrollTo).scrollIntoView();
                        }
                    });
                }
            }
        };

        // pick main page for kiosk app based on ext settings
        console.log('pick main page for kiosk app based on ext settings');
        if (player && player.hasMainMenu) {
            router.addRoutes([
                {
                    name: 'start',
                    path: '/start',
                    redirect: '/menu'
                }
            ]);
        } else {
            let lobbyCategories = [];
            if (player && player.branchParameters && player.branchParameters.kiosk) {
                const kioskParams = JSON.parse(player.branchParameters.kiosk);

                lobbyCategories = (kioskParams && kioskParams.lobby && kioskParams.lobby.items) || [];
            }

            const welcomeLinks = store.get('welcomeLinks/list');
            const isEnabledMenuItem = (items, code) => {
                return (items.find(i => i.code == code) || { enabled: false }).enabled;
            };
            const lobbyCategoriesJointed = welcomeLinks.map(item => ({
                ...item,
                enabled: isEnabledMenuItem(lobbyCategories, item.code)
            }));
            const enabledLobbyCategories = lobbyCategoriesJointed.filter(item => item.enabled);
            const pathActiveCategory = enabledLobbyCategories.length ? enabledLobbyCategories[0].path : '/lobby';

            router.addRoutes([
                {
                    name: 'start',
                    path: '/start',
                    redirect: pathActiveCategory
                },
                {
                    name: 'redirectMenu',
                    path: '/menu',
                    redirect: pathActiveCategory
                }
            ]);
        }

        xplay_setLoadingText('Launching entertainment...');
        let App = Vue.callWithTheme(t => import(`./components/app/${t}/app.vue`));
        let app = new Vue({
            mixins: [fixIdScrolling],
            el: '#app',
            store: state.store,
            router,
            render: h => h(App)
        });

        idleService.start();

        window.app = app;

        console.log('subscribing on bng messages events');
        await Vue.state.player.subscribePushMessages(msg => {
            if (msg.type == 'CashbackSingleBonusDeposited') {
                // remove this comment if cashback-bonus modal returns
                // router.push({ hash: '#cashback-bonus', query: router.currentRoute.query });

                // comment if cashback-bonus modal returns
                pushService.setRead([msg.id]);
            }
        });

        console.log('starting device state pooling');
        syncDeviceStateLoop(state.store, router);

        console.log('started application');
    } catch (e) {
        onBootsrapError(e);
    }
}

function onBootsrapError(error) {
    console.log('Failed to start', error);
    setTimeout(() => window.location.replace('/'), 5000);
}



// WEBPACK FOOTER //
// ./skins/xkiosk/main.js